import React from "react";
import { useFetcher } from "react-router-dom";
import DeleteIcon from "../../images/demo/delete_svg";
import { deleteRequest } from "./data";
import { Spinner } from "./Spinner";

export async function action({ params }) {
  await deleteRequest({ id: params.requestId });
}

export const DeleteButton = ({ requestId, color}) => {
  const fetcher = useFetcher();
  return (
    <fetcher.Form
      method='post'
      action={`/archive/requests/${requestId}/destroy`}
    >
      {fetcher.state === "loading" ? (
        <Spinner width={19} height={26.09} innerSize={15} color='#c1c1c1' />
      ) : (
        <button className='action-icon-wrapper del'>
          <DeleteIcon color={color} />
        </button>
      )}
    </fetcher.Form>
  );
};
